import React from 'react';
import { node, string, elementType, bool } from 'prop-types';
import cx from 'classnames';

const ZoneCard = ({ children, tag, nopadding, className = '' }) => {
  const Tag = tag;

  const classNames = cx('zone-card', { nopadding }, className);
  return <Tag className={classNames}>{children}</Tag>;
};

ZoneCard.propTypes = {
  children: node.isRequired,
  className: string,
  tag: elementType,
  nopadding: bool,
};

ZoneCard.defaultProps = {
  className: '',
  tag: 'div',
  nopadding: false,
};

export default ZoneCard;
